import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Dialog, DialogActions, DialogBody, DialogTitle } from '../../catalyst/dialog';
import { Button } from '../../catalyst/button';
import type { UserListItem } from '@avisoma/shared';
import backend from '../../services/backend';

export function ReactivateUserDialog({
  user,
  open,
  onClose,
}: {
  user: UserListItem | null;
  open: boolean;
  onClose: () => void;
}) {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: () => backend.activateUser(user!.id).then((res) => res.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users'] });
      onClose();
    },
  });

  if (!user) return null;

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Reactivate {user.username}?</DialogTitle>
      <DialogBody>
        <p className="text-sm text-zinc-700 dark:text-zinc-300">
          They&apos;ll be able to log in again.
        </p>
      </DialogBody>
      <DialogActions>
        <Button plain onClick={onClose}>
          Cancel
        </Button>
        <Button color="blue" onClick={() => mutation.mutate()} disabled={mutation.isPending}>
          {mutation.isPending ? 'Reactivating…' : 'Reactivate'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
